{
  "links": {
    "access_context": "Access Context",
    "support": "Support"
  },
  "firmware": {
    "navigation_title": "Firmware"
  },
  "navigation_items": {
    "home": "Home",
    "dashboards": "Dashboards",
    "devices": "Devices",
    "alerts": "Alerts",
    "map": "Map",
    "certificates": "Certificates",
    "reports": "Reports",
    "analytics": "Noesis",
    "users": "Users",
    "user_invitations": "User Invitations",
    "organizations": "Organizations",
    "partnerships": "Partnerships",
    "api_api": "API Keys",
    "webhooks": "Webhooks",
    "archives": "Archives",
    "calibrations": "Calibrations",
    "firmwares": "Firmwares",
    "access_context": "Access Context"
  },
  "subheaders": {
    "monitoring": "Monitoring",
    "analytics": "Analytics",
    "management": "Management",
    "general": "General",
    "admin": "Admin"
  }
}